export var StepName;
(function (StepName) {
    StepName["Time"] = "ChooseTime";
    StepName["Info"] = "YourInfo";
})(StepName || (StepName = {}));
;
